/*
 * @Author: 张天昊
 * @Date: 2024-06-04 15:57:35
 * @LastEditTime: 2024-06-05 10:16:05
 * @LastEditors: 张天昊
 * @Description:
 * @FilePath: /Mobile/src/pages/itineraryUniversal/composables/usePanelMinHeight.js
 */
import { ref, onMounted } from 'vue';
import { useTabsHeight } from './useTabsHeight';
export function usePanelMinHeight() {
  const panelMinHeight = ref('auto');
  const { getTabsNavHeight } = useTabsHeight();

  onMounted(() => {
    panelMinHeight.value = `calc(100vh - ${getTabsNavHeight()}px)`;
  });

  return {
    panelMinHeight
  }
}
